export const tutorialTypes = {
  BINOCULARV2CALIBRATION: 'BINOCULARV2CALIBRATION',
  BINOCULARV2: 'BINOCULARV2',
  PERCEPTUAL: 'PERCEPTUAL',
  IMAGINARY: 'IMAGINARY',
  MIXED: 'MIXED',
}
